import React from "react";
import { Card } from "primereact/card";
import { useParams } from "react-router-dom";
import AdminOnly from "../../../../components/AdminOnly";
import CustomeButton from "../../../../components/Button/index";
import useLspAddressUpdate from "../../actions/useLspAddressUpdate";
import TradingAddressForm from "../../../../components/lsp/tradingaddress/TradingAddressForm";
import Notification from "../../../../components/entities/notification/Notification";
import API_ROUTES from "../../../../api-routes";
import AuditSidebar from "../../../../components/audit-sidebar/AuditSidebar";

const LspTradingAddress = () => {
  const { id } = useParams();

  const {
    genstate,
    handleEnableEdit,
    setSuccessMsg,
    handleAdressChange,
    handleAddressUpdate,
    handleDiscardEdit,
    setAuditSidebarVisible,
  } = useLspAddressUpdate();

  const auditLabels = () => {
    return {
      create: "LSP Created",
      update: "Information Updated",
      delete: "Information Deleted",
    };
  };

  return (
    <>
      {genstate?.isAuditSidebarVisible && (
        <AuditSidebar
          heading="Trading Address"
          endpoint={API_ROUTES.FETCH_ADDRESS_AUDIT}
          id={id}
          objectType="entity"
          labels={auditLabels}
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={genstate?.isAuditSidebarVisible}
        />
      )}

      <Card className="card-onboard">
        <div className="formgrid grid flex justify-content-between mb-4">
          <p className="general-info">Trading Address</p>
          <AdminOnly>
            <div className="flex gap-1">
              {genstate.isEdit ? (
                <>
                  <CustomeButton
                    label="Discard"
                    variant="outlined"
                    className="mr-2"
                    onClick={handleDiscardEdit}
                  />
                  <CustomeButton
                    loading={genstate?.isUpdating}
                    label={!genstate?.isUpdating && "Save Changes"}
                    variant="contained"
                    onClick={handleAddressUpdate}
                    disabled={genstate?.isUpdating || genstate?.isSaveBtn}
                    className={`mr-2 access-btn  ${genstate?.isSaveBtn && "disable"}`}
                  />
                </>
              ) : (
                <>
                  <CustomeButton
                    label="View History"
                    variant="outlined"
                    className="mr-2"
                    icon="pi pi-history"
                    iconPos="right"
                    onClick={() => setAuditSidebarVisible(true)}
                  />

                  <CustomeButton
                    label="Edit"
                    variant="contained"
                    className="mr-2 access-btn"
                    onClick={handleEnableEdit}
                    icon="pi pi-pencil"
                    iconPos="right"
                  />
                </>
              )}
            </div>
          </AdminOnly>
          <Notification
            successMessage={genstate.successmsg}
            setSuccessMessage={setSuccessMsg}
          />
        </div>
        <div className="formgrid grid">
          <TradingAddressForm
            handleChange={handleAdressChange}
            data={genstate?.tradeaddress}
            isLoading={genstate.isloading}
            isEdit={genstate.isEdit}
            states={genstate.statesarray}
            cities={genstate.cityarray}
          />
        </div>
      </Card>
    </>
  );
};

export default LspTradingAddress;
